<template>
<section class="card profile-interests">
    <h1>{{ t.interests.interests }}</h1>
    <p v-if="editMode">
        <editable :options="interestOptions" :params="profileParams" property="interests" type="checkboxes"
            :value="profile.interestsIds"></editable>
    </p>
    <template v-else>
        <p v-if="!profile.interests.length">{{ t.interests.no_interests }}</p>
        <ul v-if="profile.interests.length" class="list-unstyled">
            <li v-for="(interest, index) in profile.interests" :key="index">{{ interest }}</li>
        </ul>
    </template>
</section>
</template>

<script>
import Editable from 'Site/component/Editable.vue';
import { mapState } from 'vuex';

export default {
    name: 'ProfileInterests',
    components: {
        Editable
    },
    computed: {
        ...mapState({
            config: state => state.config.data
        }),
        profileParams() { return { id: this.config.userId, url: 'profile' }; },
        interestOptions() { return this.localConfig.data.interests; }
    },
    props: {
        editMode: {
            type: Boolean,
            default: false
        },
        localConfig: {
            type: Object,
            required: true
        },
        profile: {
            type: Object,
            required: true
        },
        t: {
            type: Object,
            required: true
        }
    }
};

</script>
